import { isIOS } from 'react-device-detect';

declare global {
  interface Window {
    willWarnOnUnload: boolean;
  }
}

const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  // eslint-disable-next-line no-param-reassign
  event.returnValue =
    // The message is basically ignored but setting it here for browsers which don't ignore it.
    'Changes you made may not be saved. Are you sure you want to leave the page ?';
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return event.returnValue;
};

// on IOS the event handler is fired but no prompt for the user
const eventName = isIOS ? 'pagehide' : 'beforeunload';

export const addBeforeUnloadListener = () => {
  if (window.willWarnOnUnload) return;
  window.willWarnOnUnload = true;
  window.addEventListener(eventName, handleBeforeUnload, { capture: true });
};

export const removeBeforeUnloadListener = () => {
  if (!window.willWarnOnUnload) return;
  window.willWarnOnUnload = false;
  window.removeEventListener(eventName, handleBeforeUnload, { capture: true });
};
